import React from "react";

// queries
import { useModerators } from "../../../../hooks/useModerators";

// components
import MockApolloQuery from "../MockApolloQuery";

const GetModeratorList = () => {
    const { filteredModerators } = useModerators();

    const apolloCall = async () => {
        return filteredModerators;
    };

    return (
        <MockApolloQuery
            title={"Get List of Moderators"}
            apolloCall={apolloCall}
        />
    );
};

export default GetModeratorList;
